import validate from "/usr/src/app/content/n3-spas-c23dda93-af53-45ef-86a3-36d5f44a3148/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-spas-c23dda93-af53-45ef-86a3-36d5f44a3148/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}